import { AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';

import { IMultiUrlImage, MultiUrlImagePipe, ngHelper } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'product-img',
  templateUrl: './product-img.component.html',
  styleUrls: ['./product-img.component.scss'],
})
export class ProductImgComponent implements AfterViewInit, OnChanges {
  @Input() image: IMultiUrlImage;
  @Input() alt = '';

  @ViewChild('imageRef', { static: false }) imageRef: ElementRef;

  constructor(private _multiUrlImage: MultiUrlImagePipe) {}

  ngAfterViewInit() {
    this.imageRef.nativeElement.src = this._getUrl(this.image);
  }

  ngOnChanges(changes: SimpleChanges): void {
    ngHelper.ifChanged(changes, 'image', (image) => {
      if (this.imageRef) {
        this.imageRef.nativeElement.src = this._getUrl(image);
      }
    });
  }

  private _getUrl(image: IMultiUrlImage) {
    return this._multiUrlImage.transform(image, 'original', '/assets/img/content/default-cake-image.jpg');
  }
}
